module.exports = __webpack_public_path__ + "img/icon_order_lightgray.ad373ca6.svg";